import { RebalancingProposalMember } from './rebalancing-proposal-member.entity';

export class RebalancingProposalEntity {
  public investigationId!: string;
  public investigationNumber!: string;
  public investigationTypeName!: string;
  public investigationStatusLabel!: string;
  public isOverdue!: boolean;
  public teamId!: string;
  public teamName!: string;
  public fromMember!: RebalancingProposalMember;
  public toMember!: RebalancingProposalMember;
  public alternates!: RebalancingProposalMember[];
  public rationale!: string;
}
